import Routes from "routing/Routes";
export const PAGE_NAV_TITLE = "Lookup Tables";
const bindings = {
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      children: [
        { description: "Lookup Tables", titleKey: "navigation:page_navigation.lookup_tables", path: Routes.SYSTEM.LOOKUPTABLES.OVERVIEW, exactPathMatch: true },
        { description: "Caches", titleKey: "navigation:page_navigation.caches", path: Routes.SYSTEM.LOOKUPTABLES.CACHES.OVERVIEW },
        { description: "Data Adapters", titleKey: "navigation:page_navigation.data_adapters", path: Routes.SYSTEM.LOOKUPTABLES.DATA_ADAPTERS.OVERVIEW }
      ]
    }
  ]
};
export default bindings;
